<template>
  <!-- A global notification that can be created by admins -->
  <div :class="'alert alert-dismissible ' + classType" role="alert">
    <button v-if="!notice['ignorable']" @click="close()" type="button" class="close" aria-label="Close">
      <span aria-hidden="true">x</span>
    </button>
    <b-dropdown id="ignore-btn" v-if="notice['ignorable']" class="pull-right" text="" type="default" :disabled="false">
      <b-dropdown-item @click="ignoreNotice()">Ignore</b-dropdown-item>
      <b-dropdown-item @click="close()">Acknowledge</b-dropdown-item>
    </b-dropdown>
    <p>{{ notice['content'] }}</p>
  </div>
</template>

<style scoped>
#ignore-btn {
  margin-top: -5px;
}
</style>

<script>
  import * as types from '@/store/mutation-types'
  import { BDropdown, BDropdownItem } from 'bootstrap-vue';

  export default {
    name: 'Notice',
    props: {
      notice: {
        required: true,
        type: Object
      }
    },
    computed: {
      classType () {
        return 'alert-info'
      }
    },
    methods: {
      close () {
        this.$store.dispatch('acknowledgeNotice', this.notice['id'])
      },
      ignoreNotice () {
        this.$store.commit(types.REMOVE_NOTICE, this.notice['id'])
      }
    },
    components: {
      BDropdown,
      BDropdownItem,
    }
  }
</script>



// WEBPACK FOOTER //
// Notice.vue?52a54402